import { LoginStorage } from './../../../../login/login.storage';
import { FichaVeiculoPjService } from './../../../../ficha-veiculo-pj/services/ficha-veiculo-pj.service';
import { StorageService } from './../../../../services/storage/storage.service';
import { Component, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OperacoesGeralService } from '../../../../services/geral/operacoes/operacoes.geral.service';
import { ButtonSelectorData } from '../button-selector/button-selector-data';
import { timeout, take } from 'rxjs/operators';
import { NewModalMessageComponent } from '../../../../shared/modais/new-modal-message/new-modal-message.component';
import { TipoVeiculoHandler } from './tipo-veiculo.handler';

@Component({
  selector: 'app-tipo-veiculo',
  templateUrl: './tipo-veiculo.component.html',
  styleUrls: ['./tipo-veiculo.component.scss'],
})
export class TipoVeiculoComponent implements OnChanges {
  @Input() dadosOperacao;
  @Input() initialTipoVeiculo: string;
  @Output() tipoVeiculoChange = new BehaviorSubject<any>({});
  @ViewChild('modalMessage', { static: true })
  modalMessage: NewModalMessageComponent;

  veiculo: ButtonSelectorData = new ButtonSelectorData();
  veiculos: ButtonSelectorData[];
  produtosPorUsuario: any;
  public tipoCliente: number;
  public response: {
    descricao: string;
    ofertaMultipla: boolean;
    rendaMinima: number;
    rendaMaxima: number;
  }[] = [];

  private initialTipoVeiculoApplied = false;

  constructor(
    private operacoesGeralService: OperacoesGeralService,
    private storageService: StorageService,
    private fichaVeiculoPjService: FichaVeiculoPjService,
    private loginStorage: LoginStorage
  ) {}

  ngOnChanges() {
    this.getTipoCliente();
    this.initProdutosPorUsuario();
  }

  getTipoCliente() {
    this.tipoCliente = this.storageService.getLocal().tipoCliente;
  }

  private initProdutosPorUsuario(): void {
    const { tipoProduto } = this.dadosOperacao;
    const agentId = this.loginStorage.agenteId;

    if (this.tipoCliente) {
      this.fichaVeiculoPjService
        .produtosPorUsuario(tipoProduto, agentId, this.tipoCliente)
        .pipe(take(1))
        .subscribe(
          (res) => this.handleSuccess(res),
          (error) => this.handleError(error)
        );
    } else {
      this.fichaVeiculoPjService
        .produtosPorUsuario(tipoProduto, agentId)
        .pipe(timeout(20000), take(1))
        .subscribe(
          (res) => this.handleSuccess(res),
          (error) => this.handleError(error)
        );
    }
  }

  private handleSuccess(res: any) {
    this.response = res;
    this.veiculos = TipoVeiculoHandler.handle(res);
    this.validateVeiculosLength();
    this.applyInitialTipoVeiculo();
  }

  private handleError(error: any) {
    if (error && error.error && error.error.message) {
      this.modalMessage.showModal({
        mensagem: error.error.message,
      });
      return;
    }
    this.modalMessage.showModal({
      mensagem: 'Erro obtendo os tipos de produto.',
    });
  }

  validateVeiculosLength() {
    if (this.veiculos.length === 1) {
      const [veiculo] = this.veiculos;
      this.tipoVeiculoChange.next(veiculo.id);
      this.veiculo = veiculo;
    }
  }

  private applyInitialTipoVeiculo(): void {
    if (!this.initialTipoVeiculo || this.initialTipoVeiculoApplied || !this.veiculos) {
      return;
    }

    const selected = this.veiculos.find(
      (item) => item.id === this.initialTipoVeiculo
    );

    if (selected) {
      this.initialTipoVeiculoApplied = true;
      this.veiculo = selected;
      this.onTipoVeiculoChange();
    }
  }

  onTipoVeiculoChange() {
    this.storageService.patchLocal({
      multiplesOffers: this.response.filter(
        (item) =>
          item.descricao.toUpperCase() === this.veiculo.label.toUpperCase()
      )[0].ofertaMultipla,
    });
    this.tipoVeiculoChange.next(this.veiculo.id);
  }
}
